// extracted by mini-css-extract-plugin
module.exports = {"page_header":"OnlinePage_page_header__218g9"};